<template>
    <div>
        <div v-if="$store.state.settings.mode ==='pc'" class="main">
            <Nav :title="state" />
            <div class="container">
                <div class="center-big-box">
                    <PoliciesCenter :data-list="dataList" class="center-box" />
                    <div class="block">
                        <el-pagination
                            :page-size="5"
                            layout="total, prev, pager, next, jumper"
                            :total="total"
                            background
                            :hide-on-single-page="value"
                            @current-change="handleCurrentChange"
                        />
                    </div>
                </div>
                <NewsPolicies :policies-name="policiesName" :data-list="NewsdataList" class="right-box" />
            </div>
        </div>
        <div v-else class="mobileMain">
            <div class="head">
                <img src="../../assets/images/index/zjt.png" alt="" @click="fallback">
                <div v-if="state == '1'">新闻中心</div>
                <div v-if="state == '3'">CMCA动态</div>
                <div v-if="state == '4'">政策法规</div>
                <div v-if="state == '5'">会议活动</div>
            </div>
            <!-- <van-list
                :loading="loading"
                :finished="finished"
                :finished-text="mobileList.length ? '没有更多了' : ''"
                @load="load(true)"
            > -->
            <ul v-infinite-scroll="load" class="infinite-list" style="overflow:auto;">
                <li v-for="(item,index) in dataList" :key="index" class="infinite-list-item" @click="detailEvent(item)">
                    <div class="left">
                        <div>{{ item.xName }}</div>
                        <div>中国移动通信联合会 | {{ item.showTime }}</div>
                    </div>
                    <div class="right">
                        <img :src="item.imageFace" alt="">
                    </div>
                </li>
            </ul>
            <!-- </van-list> -->
        </div>
    </div>
</template>

<script>
import 'swiper/css/swiper.css'
import Nav from '@/layout/nav'
import PoliciesCenter from '@/layout/policies/policiesCenter'
import NewsPolicies from '@/layout/policies/newsPolicies'
export default {
    components: {
        Nav,
        PoliciesCenter,
        NewsPolicies
    },
    data() {
        return {
            policiesName: {
                name: '最新动态',
                englishName: 'News Center'
            },
            state: 0,
            limit: 5,
            dataList: [],
            NewsdataList: [],
            total: 0,
            value: true,
            bannerList: [],
            // 移动端
            mobileOffset: 0,
            mobileLimit: 5,
            mobileTotal: 0,
            loading: false,
            noMore: false,
            mobileList: [],
            finished: false
        }
    },
    watch: {
        '$route.path': function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.state = this.$router.currentRoute.params.cId
            }
        }
    },
    mounted() {
        this.state = this.$router.currentRoute.params.cId
        this.dataRequest()
        this.NewsDataRequest()
        this.bannerRequest()
    },
    beforeCreate() {
        document.querySelector('body').setAttribute(
            'style',
            'margin: 0 auto; width: 100%; background:rgba(244,245,247,1); overflow-x: hidden;height: 100%;')
    },
    methods: {
        dataRequest() {
            this.$api.get('news/xList', {
                params: {
                    cId: this.state,
                    limit: this.limit,
                    offset: 0
                }
            }).then(res => {
                this.dataList = res.data.list
                this.total = res.data.count
            })
        },
        fallback() {
            this.$router.go(-1)
        },
        detailEvent(item) {
            this.$router.push({
                name: 'PoliciesDetails',
                params: {
                    xId: item.xId
                }
            })

        },
        NewsDataRequest() {
            this.$api.get('news/xList', {
                params: {
                    cId: 1,
                    limit: 5,
                    offset: 0
                }
            }).then(res => {
                this.NewsdataList = res.data.list
            })
        },
        bannerRequest() {
            this.$api.get('banner/qList').then(res => {
                this.bannerList = res.data.list
            })
        },
        // NewsdataList
        // handleSizeChange(val) {

        // },
        load(isLoadMore) {
            this.loading = true
            this.$api.get('news/xList', {
                params: {
                    cId: this.state,
                    limit: this.mobileLimit,
                    offset: isLoadMore ? this.mobileOffset : 0
                }
            }).then(res => {
                this.loading = false
                if (!isLoadMore) {
                    this.mobileOffset = 0
                    this.mobileList = res.data.list
                } else {
                    this.mobileList = this.mobileList.concat(res.data.list)
                }
                if (res.data.count != 0) {
                    this.offset++
                    if (
                        this.mobileList.length == 0 ||
                        this.mobileList.length < res.data.count
                    ) {
                        this.finished = false
                    } else {
                        this.finished = true
                    }
                } else {
                    // this.none = true
                    this.finished = true
                }
                // if (this.mobileList.length < res.data.count) {
                //     this.mobileOffset += 1
                //     this.mobileList = this.mobileList.concat(res.data.list)
                //     this.loading = false
                // } else {
                //     this.noMore = true
                //     this.loading = false
                // }

            })
        },
        handleCurrentChange(val) {
            this.$api.get('news/xList', {
                params: {
                    cId: this.state,
                    limit: this.limit,
                    offset: val - 1
                }
            }).then(res => {
                this.dataList = res.data.list
                this.total = res.data.count
            })
        }
    }

}

</script>

<style lang="scss" scoped>
.main {
    background: rgba(244, 245, 247, 1);
    .case-container {
        width: 1920px;
        margin: 0 auto;
        position: relative;
        top: 0;
        font-size: 0;
        .bannar-box {
            width: 1920px;
            height: 360px;
        }
        .swiper-container {
            height: 100%;
            font-size: 0;
            .swiper-slide img {
                width: 100%;
                height: 100%;
                display: block;
                font-size: 0;
            }
            img {
                vertical-align: buttom;
                vertical-align: middle;
                vertical-align: top;
            }
            .swiper-slide { height: 10px; }
            .swiper-slide-active { height: auto; }
        }
        .new-list {
            position: absolute;
            top: 0;
            right: 380px;
            z-index: 99;
        }
        #map {
            width: 500px;
            height: 500px;
        }
    }
    .container {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .center-big-box {
            background-color: #fff;
            position: relative;
            margin-bottom: 60px;
            .center-box {
                width: 808px;
                height: 900px;
            }
            ::v-deep .el-pagination.is-background {
                .el-pager li:not(.disabled).active {
                    background-color: #243db3;
                }
            }
            .block {
                width: 100%;
                position: absolute;
                bottom: 60px;
                ::v-deep .el-pagination {
                    width: 634px;
                    margin: 0 auto;
                    ::v-deep li {
                        background-color: #fff;
                    }
                }
                ::v-deep .btn-next,
                ::v-deep .btn-prev {
                    background-color: #fff;
                }
            }
        }
        .right-box {
            width: 372px;
            height: 348px;
            background: rgba(255, 255, 255, 1);
        }
    }
}
.mobileMain {
    .head {
        height: 60px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #eee;
        img {
            width: 10px;
            height: 16px;
        }
        div {
            flex: 1;
            font-size: 16px;
            font-weight: 600;
            text-align: center;
            color: #000;
        }
    }
    .infinite-list {
        height: 650px;
        padding: 0;
        .infinite-list-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0 15.6px;
            padding: 20.8px 0;
            border-bottom: 1px solid rgba(12, 25, 41, 0.08);
            list-style: none;
            .left {
                flex: 1;
                height: 83.72px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                div:nth-child(1) {
                    font-size: 15.6px;
                    font-weight: 400;
                    text-align: left;
                    color: #1a1b1f;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                div:nth-child(2) {
                    font-size: 11.44px;
                    font-weight: 400;
                    text-align: left;
                    color: #999;
                }
            }
            .right {
                width: 113.88px;
                height: 83.72px;
                margin-left: 10.4px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        p {
            text-align: center;
            color: #eee;
        }
    }
}
</style>
